/**
 *
 * @/functions/image.js
 *
 */

//
// IMPORTS
//

//

//
// Resize + conversão para JPEG (qualquer tipo de imagem → JPEG)
//

const resizeAndConvertToJpeg = (file, maxDimension = 600, quality = 0.9) => {
  return new Promise((resolve, reject) => {
    if (!file) return reject("NO_FILE")

    const img = new Image()
    img.onload = () => {
      URL.revokeObjectURL(img.src) // 🔥 limpa o URL da memória

      let { width, height } = img

      // Redimensiona mantendo a proporção
      if (width > height && width > maxDimension) {
        height = Math.round((height * maxDimension) / width)
        width = maxDimension
      } else if (height > width && height > maxDimension) {
        width = Math.round((width * maxDimension) / height)
        height = maxDimension
      } else if (width === height && width > maxDimension) {
        width = height = maxDimension
      }

      // Cria canvas
      const canvas = document.createElement("canvas")
      canvas.width = width
      canvas.height = height
      const ctx = canvas.getContext("2d")

      // Desenha imagem redimensionada
      ctx.drawImage(img, 0, 0, width, height)

      // Exporta JPEG
      canvas.toBlob(blob => {
        if (!blob) return reject("BLOB_ERROR")

        // Cria um novo arquivo JPEG
        const jpegFile = new File([blob], "image.jpeg", { type: "image/jpeg" })
        resolve(jpegFile)
      },
      "image/jpeg", quality)
    }

    img.onerror = () => {
      URL.revokeObjectURL(img.src) // 🔥 limpa no erro também
      reject("BAD_IMAGE")
    }

    img.src = URL.createObjectURL(file)
  })
}

const getImageDimensions = async imageBase64 => new Promise((resolve, reject) => {
  const img = new Image()
  img.onload = () => {
    resolve({ code: 1, width: (img ?? {})?.width || null, height: (img ?? {})?.height || null })
  }
  img.onerror = error => {
    resolve({ code: 0, error: JSON.stringify(error) })
  }
  img.src = imageBase64 // Aparentemente o Image() requer que o valor dessa propriedade seja atribuído
})

export const processPickerGroupImage = imageFile => new Promise((resolve, reject) => {
  //
  // FECHOU O SELETOR SEM SELECIONAR UM ARQUIVO
  //

  if (!imageFile || typeof imageFile !== "object") {
    resolve({ code: 0, response: "CANCELLED" })
    return
  }

  //
  // VERIFICA SE O ARQUIVO SELECIONADO É DO TIPO JPEG, JPG ou PNG
  //

  const contentType = typeof ((imageFile ?? {})?.type) === "string" ? imageFile.type.split("/")[1] : ""

  if (contentType !== "png" && contentType !== "jpg" && contentType !== "jpeg") {
    resolve({ code: 0, response: "Selecione uma imagem nos formatos .jpeg, .jpg ou .png" })
    return
  }

  //
  // PROCESSA ARQUIVO SELECIONADO
  //

  const imageReader = new FileReader()
  imageReader.readAsDataURL(imageFile)

  imageReader.onload = async imageRead => {
    // NESSE PONTO O ARQUIVO DA IMAGEM JÁ FOI CARREGADO, AGORA O "CONTEÚDO DA IMAGEM" SERÁ GUARDADO NA CONSTANTE
    const imageReadBase64 = imageRead.target.result

    // TENTA OBTER AS DIMENSÕES DA IMAGEM
    const baseImageDims = await getImageDimensions(imageReadBase64)

    // VERIFICA SE CONSEGUIU OBTER AS DIMENSÕES DA IMAGEM
    if (baseImageDims.code === 0) {
      resolve({ code: 0, response: `Não foi possível processar a imagem escolhida.<br /><br /><b>Motivo</b>:<br /><span style="color: indianred">${JSON.stringify(baseImageDims.error)}</span>` })
      return
    }

    // VERIFICA SE A IMAGEM É PESADA OU GRANDE
    const MAX_SIZE = 3 * 1024 * 1024
    const minimumRequirements = []
    minimumRequirements.push(imageFile.size > MAX_SIZE ? '<span style="color: indianred">&bull; Peso máximo: 3 MB</span>' : '&bull; Peso máximo: 3 MB')
    minimumRequirements.push(baseImageDims.width < 400 ? '<span style="color: indianred">&bull; Largura mínima: 400px</span>' : '&bull; Largura mínima: 400px')
    minimumRequirements.push(baseImageDims.height < 200 ? '<span style="color: indianred">&bull; Altura mínima: 200px</span>' : '&bull; Altura mínima: 200px')
    if (imageFile.size > MAX_SIZE || baseImageDims.width < 400 || baseImageDims.height < 200) {
      resolve({ code: 0, response: `A imagem escolhida não atende algum dos requisitos mínimos:<br /><br />${minimumRequirements.join("<br />")}` })
      return
    }

    // CONVERTE A IMAGEM PARA JPEG INDEPENDENTE DO TIPO E REDIMENSIONA A 600x600
    const jpegFile = await resizeAndConvertToJpeg(imageFile, 400, 0.9)

    // VERIFICA SE O JPEG É PESADO (Nota: Impossível)
    /* if (jpegFile.size > MAX_SIZE) {
      resolve({ code: 0, response: "A imagem convertida ficou acima do limite permitido (3 MB)." })
      return
    } */

    // TENTA OBTER O BASE64 DO JPEG FINAL
    const jpegPreviewBase64 = await new Promise(res => {
      const reader = new FileReader()
      reader.onload = e => res({ result: 1, base64: e.target.result })
      reader.onerror = error => {
        res({ result: 0, error })
      }
      reader.readAsDataURL(jpegFile)
    })

    // VERIFICA SE CONSEGUIU O BASE64 DO JPEG FINAL
    if (jpegPreviewBase64.result === 0) {
      resolve({ code: 0, response: `Não foi possível converter a imagem escolhida.<br /><br /><b>Motivo</b>:<br /><span style="color: indianred">${JSON.stringify(jpegPreviewBase64.error)}</span>` })
      return
    }

    // MEDE O JPEG FINAL
    const jpegDims = await getImageDimensions(jpegPreviewBase64.base64) // usa mesma função para medir

    // A ALTURA DO JPEG FINAL NÃO PODE SER MENOR QUE 200px
    if (jpegDims.height < 200) {
      resolve({ code: 0, response: 'A imagem convertida não atende o requisito:<br /><br /><span style="color: indianred">&bull; Altura mínima: 200px</span>' })
      return
    }

    // RESPOSTA BEM SUCEDIDA
    const response = { file: jpegFile, preview: jpegPreviewBase64.base64, size: jpegFile.size, width: jpegDims.width, height: jpegDims.height }
    resolve({ code: 1, response })
    return
  }

  imageReader.onerror = mainError => {
    resolve({ code: 0, response: `Não foi possível abrir o arquivo.<br /><br /><b>Motivo</b>:<br /><span style="color: indianred">${JSON.stringify(mainError)}</span>` })
  }
})
